import React, { useEffect } from "react";
import { Container, Navbar, Offcanvas, Nav, NavDropdown } from 'react-bootstrap';
import Logo from '../../../img/Logo.svg';
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../../utils/AppContext";
import AppRoute from "../../../utils/AppRoute";

const Header = () => {
    const navigate = useNavigate();
    const { userAuthenticated, activeUser, itemInCart, isAdminAuthenticated } = useAppContext();

    useEffect(() => {
        console.log(`ActiveUser: ${activeUser}, isAuth: ${userAuthenticated}, isAdmin: ${isAdminAuthenticated}, itemInCart: ${itemInCart}`);
    }, [itemInCart, isAdminAuthenticated, userAuthenticated, activeUser]);

    const sendToLogin = () => {
        navigate(AppRoute.LOGIN);
    };

    return (
        <header>
            <Navbar bg="white" expand="lg" className="mb-3 navbar navbar-expand-lg fixed-top">
                <Container fluid="xxl" className='align-items-lg-start'>
                    <Navbar.Brand href="/shop">
                        <Navbar.Brand href="/shop">
                            <svg id='logo' className="logo" viewBox="0 0 87.9 56.7" xmlns="http://www.w3.org/2000/svg"
                                 alt={'Nuoto Sport Locarno'}>
                                <g>
                                    <path
                                        d="M78.9,50.5c0-1.9,1.1-3.2,2.8-3.2s2.8,1.3,2.8,3.2-1.1,3.2-2.8,3.2c-1.60001,0-2.8-1.3-2.8-3.2m2.8,6.2c3.7,0,6.2-2.5,6.2-6.2s-2.5-6.2-6.2-6.2c-3.6,0-6.2,2.5-6.2,6.2s2.6,6.2,6.2,6.2m-18.7-.4h3.3v-6.7c0-1.5,.8-2.4,2.2-2.4,1.3,0,2,.8,2,2.3v6.8h3.3v-7.1c0-3.1-1.8-5-4.7-5-1.4,0-2.6,.5-3.3,1.5v-1.2h-2.8v11.8Zm-9.5,0h3.3v-6.9c0-1.3,.6-2,1.9-2h2.5v-2.9h-2.1c-1.5,0-2.5,.7-2.7,2.1v-2.1h-2.9v11.8Zm-10.7-3.5c0-.6,.5-1.2,1.5-1.3l2.5-.2v.5c0,1.4-1,2.1-2.4,2.1-1,.1-1.6-.3-1.6-1.1m1.3,3.9c1.6,0,2.9-.6,3.6-1.5,0,.7,.5,1.2,1.4,1.2h2.4v-2.6h-1c-.2,0-.3-.1-.3-.3v-5.2c0-2.5-1.7-3.9-4.6-3.9-3.4,0-5,1.4-5.3,3.8h3.3c.1-.8,.6-1.1,1.8-1.1s1.7,.4,1.7,1.5v.5l-3,.2c-2.9,.2-4.3,1.7-4.3,3.9-.3,2.09999,1.5,3.5,4.3,3.5m-11.6,0c3.4,0,5.4-2.3,5.7-4.7h-3.4c-.2,1-1,1.7-2.2,1.7-1.5,0-2.6-1.2-2.6-3.2s1-3.3,2.6-3.3c1.2,0,2,.7,2.1,1.5h3.4c-.2-2.7-2.4-4.5-5.5-4.5-3.6,0-6.1,2.6-6.1,6.3,.1,3.6,2.3,6.2,6,6.2m-16.2-6.2c0-1.9,1.1-3.2,2.8-3.2s2.8,1.3,2.8,3.2-1.1,3.2-2.8,3.2-2.8-1.3-2.8-3.2m2.8,6.2c3.7,0,6.2-2.5,6.2-6.2s-2.5-6.2-6.2-6.2c-3.6,0-6.2,2.5-6.2,6.2,0,3.7,2.5,6.2,6.2,6.2m-17.9-.4H12v-3.2H4.6v-13.4H1.2v16.6Z"/>
                                </g>
                                <g>
                                    <path
                                        d="M59.1,36.5h3.7v-2.9h-2.5c-.8,0-1-.3-1-1v-4.9h3.5v-2.9h-3.5v-3.4h-3.3v3.4h-3v2.9h3v5.7c0,2.2,1,3.1,3.1,3.1m-14.9,0h3.3v-6.9c0-1.3,.6-2,1.9-2h2.5v-2.9h-2.1c-1.5,0-2.5,.7-2.7,2.1v-2.1h-2.9v11.8Zm-11-5.9c0-1.9,1.1-3.2,2.8-3.2s2.8,1.3,2.8,3.2-1.1,3.2-2.8,3.2-2.8-1.3-2.8-3.2m2.7,6.3c3.7,0,6.2-2.5,6.2-6.2s-2.5-6.2-6.2-6.2c-3.6,0-6.2,2.5-6.2,6.2s2.6,6.2,6.2,6.2m-16.7-6.3c0-1.9,1.1-3.2,2.7-3.2,1.7,0,2.8,1.3,2.8,3.2s-1.1,3.2-2.8,3.2c-1.6,.1-2.7-1.3-2.7-3.2m-3.3,10.2h3.3v-5.2c.7,.8,1.9,1.3,3.2,1.3,3.4,0,5.6-2.5,5.6-6.2s-2.3-6.2-5.6-6.2c-1.5,0-2.9,.5-3.6,1.5v-1.1h-2.9v15.9Zm-9-3.9c4,0,6.5-2.2,6.5-5.5,0-2.9-1.7-4.5-5-5l-1.8-.2c-1.8-.2-2.6-.8-2.6-1.9s1.1-1.9,2.7-1.9c1.8,0,2.9,.7,2.9,2h3.5c-.1-3-2.4-5-6.4-5-3.7,0-6.2,2-6.2,5.1,0,2.7,1.6,4.4,5,4.8l1.9,.2c1.7,.2,2.4,.8,2.4,2,0,1.4-1.1,2.2-2.9,2.2-2.1,0-3.4-1-3.4-2.5H0c0,3.6,2.6,5.7,6.9,5.7"/>
                                </g>
                                <g>
                                    <path
                                        d="M58.7,10.8c0-1.9,1.1-3.2,2.8-3.2s2.8,1.3,2.8,3.2-1.1,3.2-2.8,3.2c-1.6,0-2.8-1.3-2.8-3.2m2.8,6.2c3.7,0,6.2-2.5,6.2-6.2s-2.5-6.2-6.2-6.2c-3.6,0-6.2,2.5-6.2,6.2,0,3.7,2.60001,6.2,6.2,6.2m-11.1-.3h3.7v-2.9h-2.5c-.8,0-1-.3-1-1V7.8h3.5v-2.9h-3.5V1.5h-3.3v3.4h-2.9v2.9h2.9v5.7c-.1,2.3,.9,3.2,3.1,3.2m-15.8-5.9c0-1.9,1.1-3.2,2.8-3.2s2.8,1.3,2.8,3.2-1.1,3.2-2.8,3.2-2.8-1.3-2.8-3.2m2.8,6.2c3.7,0,6.2-2.5,6.2-6.2s-2.5-6.2-6.2-6.2c-3.6,0-6.2,2.5-6.2,6.2s2.6,6.2,6.2,6.2m-14.7,0c1.3,0,2.5-.4,3.3-1.3v1h2.9V4.9h-3.3v6.7c0,1.5-.8,2.4-2.2,2.4-1.3,0-2-.8-2-2.3V4.9h-3.3v7.1c0,3.2,1.7,5,4.6,5m-21.5-.3h3.4V5.5l6.1,11.2h4.1V0h-3.4V11.2L5.3,0H1.2V16.7Z"/>
                                </g>
                            </svg>
                        </Navbar.Brand>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-lg`} />
                    <Navbar.Offcanvas
                        id={`offcanvasNavbar-expand-lg`}
                        aria-labelledby={`offcanvasNavbarLabel-expand-lg`}
                        placement="end"
                        className={'flex-grow-0'}
                    >
                        <Offcanvas.Header closeButton>
                            <Navbar.Brand href="/shop">
                                <img src={Logo} alt={'Logo Nuoto Sport Locarno'} className="logo"/>
                            </Navbar.Brand>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                            <Nav className="justify-content-end flex-grow-1 pe-3">
                                <Nav.Link href="https://www.nuotosportlocarno.ch/nsl/corsi/condizioni-generali.html" className={'nav-link'}>Condizioni generali</Nav.Link>
                                <NavDropdown
                                    title={userAuthenticated && activeUser ? activeUser : "Login"}
                                    id={`offcanvasNavbarDropdown-expand-lg`}
                                    className={'icon-nav icon-user'}
                                    onClick={() => userAuthenticated ? null : sendToLogin()}
                                >
                                    {userAuthenticated ? (
                                        <>
                                            <NavDropdown.Item href="/shop/account">I miei dati</NavDropdown.Item>
                                            <NavDropdown.Item href="/shop/history">Storico ordini</NavDropdown.Item>
                                            {isAdminAuthenticated && (
                                                <NavDropdown.Item href={AppRoute.ADMIN}>Admin</NavDropdown.Item>
                                            )}
                                        </>
                                    ) : (
                                        <>
                                        </>
                                    )}
                                </NavDropdown>
                                <Nav.Link href="/shop/cart" className={'nav-link icon-nav icon-cart'}>
                                    {itemInCart > 0 && <span className={'info-basket'}>{itemInCart}</span>}
                                    <span className={'d-lg-none'}>Carrello</span>
                                </Nav.Link>
                            </Nav>
                        </Offcanvas.Body>
                    </Navbar.Offcanvas>
                </Container>
            </Navbar>
        </header>
    );
};

export default Header;
